import { useEffect, useState } from 'react';
import { useApiLoadingStore } from '../../core/services/ApiLoadingStore';

export const GlobalLoadingBar = () => {
  const isVisible = useApiLoadingStore((state) => state.isVisible);
  const progress = useApiLoadingStore((state) => state.progress);

  const [isSlowLoading, setIsSlowLoading] = useState(false);

  useEffect(() => {
    if (!isVisible) {
      setIsSlowLoading(false);
      return;
    }

    const timer = setTimeout(() => {
      setIsSlowLoading(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <div className="global-loading-bar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress)}>
        <div className="global-loading-bar__fill" style={{ width: `${progress}%` }} />
      </div>

      {isSlowLoading && (
        <div className="global-loading-hint">
          Conectando ao banco e carregando dados...
        </div>
      )}
    </>
  );
};
